import RangePrimitive from './RangePrimitive';
import { IRangePrimitive } from './RangePrimitive.interface';

export default RangePrimitive;
export { RangePrimitive, IRangePrimitive };
